import React from 'react';
import { UserPlus, Nfc, Bell, CheckCircle } from 'lucide-react';

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-white py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-slate-900 mb-8">
          ¿Cómo Funciona TapPet?
        </h1>
        <p className="text-xl text-center text-slate-600 mb-20 max-w-3xl mx-auto">
          Un sistema simple que conecta clínicas veterinarias con dueños de mascotas en tiempo real
        </p>

        <div className="grid md:grid-cols-2 gap-16 mb-20">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1552441168-52f33365cea9?auto=format&fit=crop&w=800&q=80"
              alt="Escaneo NFC"
              className="rounded-2xl shadow-xl mb-8"
            />
          </div>
          <div className="flex flex-col justify-center space-y-8">
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <UserPlus className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">1. Registro de Caso</h3>
                <p className="text-slate-600">La clínica crea un caso cuando el dueño deja su mascota y genera un código NFC</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <Nfc className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">2. Acceso Instantáneo</h3>
                <p className="text-slate-600">El dueño recibe un código NFC con un link seguro y puede ver el timeline de su mascota en cualquier momento</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <Bell className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">3. Actualizaciones</h3>
                <p className="text-slate-600">La clínica agrega actualizaciones, notas y fotos que el dueño ve en tiempo real</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <CheckCircle className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">4. Cierre Seguro</h3>
                <p className="text-slate-600">Al terminar, el caso se cierra y el link expira automáticamente</p>
              </div>
            </div>
          </div>
        </div>

        {/* Estados del caso */}
        <div className="bg-slate-50 rounded-3xl p-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Estados del Caso</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-slate-500 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">Recibido</h4>
              <p className="text-sm text-slate-600">La mascota ha sido admitida en la clínica</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-amber-500 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">En Evaluación</h4>
              <p className="text-sm text-slate-600">El veterinario está examinando a la mascota</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-amber-500 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">En Procedimiento</h4>
              <p className="text-sm text-slate-600">Se está realizando el tratamiento o cirugía</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-green-500 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">En Recuperación</h4>
              <p className="text-sm text-slate-600">La mascota se está recuperando</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-green-500 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">Listo para Recoger</h4>
              <p className="text-sm text-slate-600">La mascota puede ser recogida</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="w-3 h-3 bg-slate-400 rounded-full mb-3"></div>
              <h4 className="font-semibold text-slate-900 mb-2">Cerrado</h4>
              <p className="text-sm text-slate-600">El caso ha sido finalizado</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
